import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';

import useContentAccessLevel from 'src/hooks/useContentAccessLevel';

import { ComponentProps } from 'lib/ComponentProps';

import { parseAccessLevelRouteFields } from 'src/mappers/fields/parseAccessLevelContent';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import { EditorHelp } from '../_EditorHelp/_EditorHelp';

import styles from './TwentyFiveFiftyTwentyFive.module.css';

type TwentyFiveFiftyTwentyFiveProps = ComponentProps & {
	fields: {
		WildCardContentId: string;
		WildCardContentUrl: string;
	};
	showNavigationContainer: boolean;
	setShowNavigationContainer: (arg0: boolean) => void;
};

export default function TwentyFiveFiftyTwentyFive(props: TwentyFiveFiftyTwentyFiveProps): JSX.Element {
	const router = useRouter();

	const isEditing = IsSitecoreEditing();

	const access = parseAccessLevelRouteFields(props.rendering.fields);
	const { isAllowedAccessToContent } = useContentAccessLevel(access);

	const [isAllowedAccess, setIsAllowedAccess] = useState(true);

	useEffect(() => {
		setIsAllowedAccess(router.asPath.includes(process.env.NEXT_PUBLIC_CONTENT_OVERVIEW_EXPOSE_CONTENT || ''));
	}, []);

	return (
		<>
			<EditorHelp text="Twenty Five Fifty Twenty Five START" indent color={'blue'} />
			<section className={`${styles.grid} pad maxWidth`}>
				<div>
					<Placeholder
						name="rcnlearn-twentyfiveleft"
						rendering={props.rendering}
						showNavigationContainer={props.showNavigationContainer}
						setShowNavigationContainer={props.setShowNavigationContainer}
					/>
				</div>
				{(isAllowedAccess || isAllowedAccessToContent || isEditing) && (
					<div className={styles.authorised} id={props.fields.WildCardContentUrl?.split('/').pop()?.toLowerCase()}>
						<Placeholder name="rcnlearn-fiftymiddle" rendering={props.rendering} />
					</div>
				)}
				{!(isAllowedAccess || isAllowedAccessToContent) && !isEditing && (
					<div className={isEditing ? styles.unauthorised : ''}>
						<EditorHelp text="The below components are shown when the user is not authorised to view the content" />
						<Placeholder name="rcnlearn-unauthorised" rendering={props.rendering} />
						<EditorHelp text="END" />
					</div>
				)}
				{(isAllowedAccess || isAllowedAccessToContent || isEditing) && (
					<div className={styles.twentyFiveRight}>
						<Placeholder name="rcnlearn-twentyfiveright" rendering={props.rendering} />
					</div>
				)}
			</section>
			<EditorHelp text="Twenty Five Fifty Twenty Five END" indent color={'blue'} />
		</>
	);
}
